<template>
  <div :class="classes">
    <pt-page-title title="活动报名详情"></pt-page-title>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-active-sign-detail'

export default {
  name: 'pt-active-sign-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    id: {
      type: String
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
